import axios from '../../../axios/index.js'
// import store from '../../../../store/store.js'
import { API_END_POINT_AUTH, API_END_POINT_USER, API_END_POINT } from '../../../../config/commonConfig'
import _ from 'lodash'

export const handleServerError = (response) => {
  const messages = []
  if (response.data) {
    if (response.data.data) {
      const responseData = response.data.data
      if (_.isArray(responseData)) {
        responseData.map((res) => {
          if (res.messages) {
            res.messages.map((mes) => {
              messages.push({id: mes.id, message: mes.message})
            })
          }
        })
      } else if (_.isObject(responseData)) {
        if (responseData.message) {
          messages.push({id: responseData.id, message: responseData.message})
        }
      }
    } 
    if (!messages.length && response.data.error && response.data.message) {
      const responseMessage = response.data.message
      if (_.isObject(responseMessage)) {
        if (responseMessage.message) {
          messages.push({id: responseMessage.message, message: responseMessage.message})
        }
      } else {
        messages.push({id: responseMessage, message: responseMessage})
      }
    }
  }
  if (!messages.length) {
    messages.push({id:'unknow_error', message:'Unknow Error'})
  }
  return { error: true, messages }
}

export default {
  init () {
    axios.interceptors.response.use(
      function (response) {
        if (response.data) {
          if (response.data.error) {
            return Promise.reject(handleServerError(response))
          }
        }
        return response
      },
      function (error) {
        const { response } = error
        if (response) {
          return Promise.reject(handleServerError(response))
        }
        return Promise.reject({ error: true, messages: [{id:'unknow_error', message:'Unknow Error'}] })
      })
  },
  forgotPassword (email) {
    return axios.post(`${API_END_POINT_AUTH}forgot-password`, {
      email
    })
  },
  resetPassword (code, password, passwordConfirmation) {
    return axios.post(`${API_END_POINT_AUTH}reset-password`, {
      code,
      password,
      passwordConfirmation
    })
  },
  sendEmailConfirmation (email) {
    return axios.post(`${API_END_POINT_AUTH}send-email-confirmation`, {
      email
    })
  },
  login (email, pwd) {
    return axios.post(`${API_END_POINT_AUTH}local`, {
      identifier:email,
      password: pwd
    })
  },
  registerUser (name, email, pwd) {
    return axios.post(`${API_END_POINT_AUTH}local/register`, {
      username: name,
      displayName: name,
      email,
      password: pwd
    })
  },
  getUserInfo (token) {
    return axios.get(`${API_END_POINT_USER}me`, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  refreshToken () {
    return axios.post('/api/auth/refresh-token', {accessToken: localStorage.getItem('accessToKen')})
  },
  validate (data) {
    return axios.post(`${API_END_POINT}/validate`, data, {
      headers: {
        'Content-Type': 'application/json'
      } 
    })
  },
  registerUserWithHash ({email, displayName, hash, password, ref}) {
    return axios.post(`${API_END_POINT}/new-user-register-confirm`, {
      email, hash, password, displayName, ref
    }, {
      headers: {
        'Content-Type': 'application/json'
      } 
    })
  },
  signupWithEmail ({email}) {
    return axios.post(`${API_END_POINT}/new-register`, {email}, {headers: {
      'Content-Type': 'application/json'
    }})
  }
}
